import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import Layout from "../../../components/Layout";
import { AuthContext } from "../../../context/authContext";
import { usersThunk } from "../../../redux/action/users/users.thunk";
import { RootState } from "../../../redux/store/rootReducer";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { useDispatch, useSelector } from "react-redux";
import { PageBody } from "../../../components/Loader";
import moment from "moment";
import { useHistory, RouteComponentProps, useLocation } from "react-router-dom";
import { getWarehousesWithState } from "./manage season/states/dataFetchingFunctions";
import { seasonService } from "../../../Services";
const WarehouseManagerDashboard = () => {
  const { user }: any = React.useContext(AuthContext);
  const { activity }: any = useSelector((state: RootState) => state.act);
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const dispatch = useDispatch();

  const [warehouse, setWarehouse] = React.useState<any>([]);
  const [warehouseCount, setWarehouseCount] = React.useState(0);

  const getWerehouse = async () => {
    updateLoader(true, "Fetching Data");
    try {
      const response = await seasonService.getAllWerehouse();
      console.log("Full Response:", response);

      if (response?.data?.data?.warehouseData) {
        setWarehouse(response.data.data.warehouseData);

        const warehouseCount = response.data.data.warehouses || 0;
        console.log("Total Warehouse Count:", warehouseCount);

        setWarehouseCount(warehouseCount);
      } else {
        console.error(
          "Warehouse data not found in the expected structure:",
          response.data
        );
      }

      updateLoader(false, "");
    } catch (error) {
      console.error("Error fetching warehouses:", error);
      updateLoader(false, "");
    }
  };

  React.useEffect(() => {
    getWerehouse();
  }, []);

  return (
    <PageBody isLoading={isLoading} message={message}>
      <Layout active="">
        <div className="d-flex">
          {/* Main content area */}
          <div className="flex-grow-1 p-4">
            <div className="d-flex mb-4">
              {/* First Card - Warehouse Manager Name */}
              <Card
                className="mr-4 border-0"
                style={{
                  backgroundColor: "#348C16",
                  width: "200px",
                  height: "120px",
                }}
              >
                <CardBody className="text-white">
                  <h5>Good Afternoon</h5>
                  {/* <h4>{user.data.data.name}</h4> */}
                  {user?.firstName + " " + user?.lastName}{" "}
                  {/* <small>Warehouse Manager</small> */}
                </CardBody>
              </Card>

              {/* Second Card - Warehouse Count */}
              <Card
                className="border-0"
                style={{
                  backgroundColor: "#348C16",
                  width: "200px",
                  height: "120px",
                }}
              >
                <CardBody className="text-white text-center d-flex flex-column justify-content-center align-items-center">
                  <div>Warehouse</div>
                  <h1 className="display-4">{warehouseCount}</h1>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
        <Row>
          <Col>
            <Card className=" border-0 shadow mt-5">
              <CardBody>
                <div className="clearfix">
                  <div className="float-left">
                    <h6 className="font-weight-bold my-3">Activity Log</h6>
                  </div>
                  <div className="float-right">
                    {/* <small className="font-weight-bold">View All</small> */}
                  </div>
                </div>

                <Table hover responsive>
                  <tbody>
                    {activity?.data?.length < 1 ? (
                      <div className="text-center m-auto">
                        <h1>No record found</h1>
                      </div>
                    ) : (
                      activity?.data?.map((act: any, i: any) => (
                        <tr className="mt-3">
                          <td scope="row">{i + 1}</td>
                          <td className="font-weight-bold">
                            {act.description}
                          </td>

                          <td>{moment(act.dateCreated).format("LLLL")}</td>
                          <td>
                            {" "}
                            {moment(act.dateCreated).startOf("hour").fromNow()}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Layout>
    </PageBody>
  );
};

export default WarehouseManagerDashboard;
